import { useRef } from "react";
import { ASSETS } from "@/data/site";

export default function ProductVisual({ caption = "BNM Carbon Free Generator — Prototype" }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${((e.clientX - rect.left) / rect.width) * 100}%`);
    el.style.setProperty("--my", `${((e.clientY - rect.top) / rect.height) * 100}%`);
  };

  return (
    <div data-testid="product-visual" className="relative">
      <div className="absolute -inset-4 sm:-inset-8 rounded-2xl bg-volt/10 blur-2xl animate-pulse-glow pointer-events-none" aria-hidden="true" />
      <div
        ref={ref}
        onMouseMove={onMove}
        className="spotlight-card relative rounded-lg border border-volt/25 bg-pine shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6)]"
      >
        <span className="absolute top-3 left-3 h-5 w-5 border-t-2 border-l-2 border-volt/70" aria-hidden="true" />
        <span className="absolute top-3 right-3 h-5 w-5 border-t-2 border-r-2 border-volt/70" aria-hidden="true" />
        <span className="absolute bottom-3 left-3 h-5 w-5 border-b-2 border-l-2 border-volt/70" aria-hidden="true" />
        <span className="absolute bottom-3 right-3 h-5 w-5 border-b-2 border-r-2 border-volt/70" aria-hidden="true" />
        <img
          src={ASSETS.generator}
          alt="The BNM Carbon Free Generator — official photo of the 500W prototype unit"
          className="w-full h-auto block"
          loading="eager"
          width="1024"
          height="768"
        />
      </div>
      <div className="mt-4 flex items-center justify-between">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-volt/80">{caption}</p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">UNIT 01</p>
      </div>
    </div>
  );
}
